import React, { useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  CANCEL: {
    id: 'EditableEventText.CANCEL',
    defaultMessage: 'Abbrechen',
  },
  SAVE: {
    id: 'EditableEventText.SAVE',
    defaultMessage: 'Speichern',
  },
  SAVING: {
    id: 'EditableEventText.SAVING',
    defaultMessage: 'Speichert...',
  },
  ERROR_SAVING: {
    id: 'EditableEventText.ERROR_SAVING',
    defaultMessage: 'Fehler beim Speichern',
  },
  EDIT: {
    id: 'EditableEventText.EDIT',
    defaultMessage: 'Bearbeiten',
  },
});

const EditableEventText = ({ text, eventId, onSave, label }) => {
  const intl = useIntl();
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text || '');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = () => {
    setIsSaving(true);
    onSave(eventId, value).then(() => {
      setIsSaving(false);
      setIsEditing(false);
    }).catch(() => {
      setIsSaving(false);
      alert(intl.formatMessage(messages.ERROR_SAVING));
    });
  };

  if (isEditing) {
    return (
      <div style={{ 
        marginTop: '8px', 
        marginBottom: '8px',
        background: '#fff', 
        padding: '12px', 
        borderRadius: '12px', 
        border: 'none',
        boxShadow: '0 4px 15px rgba(0,0,0,0.05)'
      }}>
        {label && <strong style={{ display: 'block', marginBottom: '8px', color: '#475569' }}>{label}</strong>}
        <textarea
          style={{ 
            width: '100%', 
            minHeight: '60px', 
            padding: '8px', 
            fontSize: '13px',
            border: 'none',
            borderBottom: '2px solid transparent',
            outline: 'none',
            resize: 'vertical',
            transition: 'border-color 0.2s ease',
            backgroundColor: 'transparent'
          }}
          onFocus={e => e.currentTarget.style.borderBottom = '2px solid var(--primary-color)'}
          onBlur={e => e.currentTarget.style.borderBottom = '2px solid transparent'}
          value={value}
          onChange={e => setValue(e.target.value)}
          disabled={isSaving}
          autoFocus
        />
        <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button 
            className="lh-btn lh-btn-default lh-btn-small" 
            onClick={() => { setIsEditing(false); setValue(text); }}
            disabled={isSaving}
            style={{ height: '30px', boxSizing: 'border-box', padding: '6px 14px', fontSize: '11px', borderRadius: '6px', border: 'none', background: '#f1f5f9', color: '#475569' }}
          >
            {intl.formatMessage(messages.CANCEL)}
          </button>
          <button 
            className="lh-btn lh-btn-primary lh-btn-small" 
            onClick={handleSave}
            disabled={isSaving}
            style={{ height: '30px', boxSizing: 'border-box', padding: '6px 14px', fontSize: '11px', borderRadius: '6px' }}
          >
            {isSaving ? intl.formatMessage(messages.SAVING) : intl.formatMessage(messages.SAVE)}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div 
      style={{ position: 'relative', display: 'inline-block', width: '100%' }}
      onMouseEnter={e => e.currentTarget.querySelector('.edit-icon').style.opacity = 1}
      onMouseLeave={e => e.currentTarget.querySelector('.edit-icon').style.opacity = 0}
    >
      <div style={{ paddingRight: '35px', minHeight: '28px', display: 'flex', alignItems: 'center' }}>
        {label ? (<span><strong style={{ color: '#475569' }}>{label}:</strong> {text}</span>) : <span>{text}</span>}
      </div>
      <div
        className="edit-icon"
        onClick={() => setIsEditing(true)}
        style={{ 
          position: 'absolute', 
          top: '50%',
          transform: 'translateY(-50%)',
          right: 0, 
          cursor: 'pointer', 
          color: '#64748b', 
          opacity: 0, 
          transition: 'all 0.2s ease',
          width: '28px',
          height: '28px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f5f9'}
        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
        title={intl.formatMessage(messages.EDIT)}
      >
        <i className="fa fa-pencil" style={{ fontSize: '12px' }} />
      </div>
    </div>
  );
};

export default EditableEventText;
